class CompleteLook extends HTMLElement {
  connectedCallback() {
    this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-look-item]'));
    if (!this.rows.length) return;

    this.countEl = this.querySelector('[data-look-count]');
    this.totalEl = this.querySelector('[data-look-total]');
    this.noteEl = this.querySelector('[data-look-note]');
    this.errorEl = this.querySelector('[data-look-error]');
    this.addButton = this.querySelector('[data-look-add]');

    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.freeLabel = this.dataset.freeLabel || '';
    this.wordOne = this.dataset.wordOne || '';
    this.wordMany = this.dataset.wordMany || '';

    this.rows.forEach((row) => {
      var id = row.dataset.lookItem;
      var pin = this.querySelector('[data-pin="' + id + '"]');

      row.addEventListener('click', () => this.toggle(id));
      row.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          row.click();
        }
      });

      if (!pin) return;
      pin.addEventListener('click', () => this.toggle(id));

      var pair = [row, pin];
      pair.forEach((el) => {
        ['pointerenter', 'focus'].forEach((type) =>
          el.addEventListener(type, () => pair.forEach((p) => p.classList.add('is-highlighted')))
        );
        ['pointerleave', 'blur'].forEach((type) =>
          el.addEventListener(type, () => pair.forEach((p) => p.classList.remove('is-highlighted')))
        );
      });
    });

    if (this.addButton) this.addButton.addEventListener('click', () => this.add());

    this.render();
  }

  get selected() {
    return this.rows.filter((row) => row.dataset.selected === 'true');
  }

  toggle(id) {
    var row = this.querySelector('[data-look-item="' + id + '"]');
    if (!row || row.disabled) return;

    var stage = this.querySelector('.look__stage');
    if (stage) stage.classList.add('is-touched');

    var isOn = row.dataset.selected === 'true';
    if (isOn && this.selected.length === 1) return;

    row.dataset.selected = isOn ? 'false' : 'true';
    row.classList.toggle('is-on', !isOn);
    row.setAttribute('aria-checked', String(!isOn));

    var pin = this.querySelector('[data-pin="' + id + '"]');
    if (pin) pin.classList.toggle('is-on', !isOn);

    this.render();
  }

  render() {
    var chosen = this.selected;
    var total = chosen.reduce(function (sum, row) {
      return sum + (parseInt(row.dataset.price, 10) || 0);
    }, 0);

    if (this.countEl) {
      var word = chosen.length === 1 ? this.wordOne : this.wordMany;
      this.countEl.textContent = (chosen.length + ' ' + word).trim();
    }

    if (this.totalEl) this.totalEl.textContent = window.RappitUtils.formatMoney(total);

    if (this.noteEl) {
      var shipsFree = this.threshold > 0 && total >= this.threshold;
      this.noteEl.textContent = shipsFree ? this.freeLabel : '';
      this.noteEl.hidden = !shipsFree;
    }

    if (this.addButton) this.addButton.disabled = chosen.length === 0;
  }

  add() {
    var items = this.selected
      .filter(function (row) {
        return row.dataset.variant && row.dataset.available === 'true';
      })
      .map(function (row) {
        return { id: row.dataset.variant, quantity: 1 };
      });

    if (!items.length) return;

    this.addButton.setAttribute('aria-busy', 'true');
    if (this.errorEl) this.errorEl.hidden = true;

    window.RappitCart.add(items)
      .then(() => {
        if (window.Rappit.cartType === 'drawer') {
          window.RappitDrawers.open('CartDrawer', this.addButton);
        } else {
          window.location.href = window.Rappit.routes.cart;
        }
      })
      .catch((error) => {
        if (this.errorEl) {
          this.errorEl.textContent = error.message;
          this.errorEl.hidden = false;
        } else {
          window.RappitUtils.toast(error.message, 'error');
        }
      })
      .finally(() => this.addButton.setAttribute('aria-busy', 'false'));
  }
}

if (!customElements.get('complete-look')) {
  customElements.define('complete-look', CompleteLook);
}
